// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --settings-primary: #201157;
  --settings-primary-text: #ffffff;
  --settings-primary-dark: #201157;
  --settings-accent: #EB266A;
  --settings-heading: #201157;
  --settings-body: #555555;
  --settings-card-bg: #f5f5fa;
  --settings-bg: #f6f3ff;
  --settings-link: #201157;
  --settings-btn-text: #ffffff;
  --settings-ring-color: #201157;
}

.settings-header ion-toolbar {
  --border-width: 0 !important;
  --background: var(--settings-primary);
  --color: var(--settings-primary-text);
  --min-height: 52px;
  padding: 0 4px;
}
.settings-header ion-toolbar.settings-toolbar {
  border-bottom: none;
}

.settings-title {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.2px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 0 48px;
  pointer-events: none;
}

.header-icon {
  width: 20px;
  height: 20px;
  color: var(--settings-primary-text);
}

.settings-content {
  --background: var(--settings-bg);
}
.settings-content ::ng-deep .inner-scroll {
  background: var(--settings-bg);
}

.settings-scroll {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 16px 32px;
  max-width: 480px;
  margin: 0 auto;
  animation: fadeInUp 0.35s ease both;
}

.section-card {
  display: flex;
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.section-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.section-card:active {
  transform: translateY(0);
}
.section-card + .section-card {
  animation: fadeInUp 0.35s ease both;
  animation-delay: 0.08s;
}
.section-card + .section-card + .section-card {
  animation-delay: 0.16s;
}

.card-accent {
  flex-shrink: 0;
  width: 3px;
  background: var(--settings-accent);
  border-radius: 0 2px 2px 0;
}
.card-accent--danger {
  background: var(--ion-color-danger, #f04141);
}

.card-body {
  flex: 1;
  min-width: 0;
  padding: 16px 16px 12px;
}

.section-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: var(--settings-body);
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-bottom: 10px;
  opacity: 0.6;
}

.language-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0 4px;
}
.language-trigger .flag-icon {
  font-size: 22px;
  line-height: 1;
  margin: 0;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.language-trigger .lang-code {
  font-size: 14px;
  font-weight: 600;
  color: var(--settings-heading);
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.language-trigger .chevron-icon {
  margin-left: auto;
  width: 14px;
  height: 14px;
  color: var(--settings-body);
  opacity: 0.35;
  transform: rotate(180deg);
}

.settings-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.settings-item:hover {
  opacity: 0.75;
}
.settings-item:active {
  opacity: 0.55;
}
.settings-item + .settings-item {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
.settings-item .item-icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  font-size: 18px;
  color: var(--settings-link);
  opacity: 0.7;
}
.settings-item .item-label {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: var(--settings-heading);
  line-height: 1.3;
}
.settings-item .chevron-icon {
  width: 14px;
  height: 14px;
  color: var(--settings-body);
  opacity: 0.25;
  transform: rotate(180deg);
  flex-shrink: 0;
}

.card-danger .item-icon--danger {
  color: var(--ion-color-danger, #f04141);
  opacity: 1;
}
.card-danger .item-label--danger {
  color: var(--ion-color-danger, #f04141);
  font-weight: 500;
}

.doc-view {
  padding: 20px 16px 32px;
  max-width: 480px;
  margin: 0 auto;
  animation: fadeInUp 0.3s ease both;
}

.doc-content {
  background: #ffffff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04);
  font-size: 14px;
  line-height: 1.65;
  color: var(--settings-body);
}
.doc-content * {
  max-width: 100%;
  word-break: break-word;
}
.doc-content p {
  margin: 0 0 12px;
}
.doc-content p:last-child {
  margin-bottom: 0;
}
.doc-content a {
  color: var(--settings-link);
}
.doc-content img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}
.doc-content h1, .doc-content h2, .doc-content h3, .doc-content h4, .doc-content h5, .doc-content h6 {
  color: var(--settings-heading);
  font-weight: 600;
  line-height: 1.3;
}
.doc-content h1 {
  font-size: 20px;
  margin: 0 0 12px;
}
.doc-content h2 {
  font-size: 18px;
  margin: 0 0 10px;
}
.doc-content h3 {
  font-size: 16px;
  margin: 0 0 8px;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media screen and (min-width: 768px) {
  .settings-header ion-toolbar {
    --min-height: 56px;
  }
  .settings-scroll {
    padding: 28px 20px 40px;
    gap: 18px;
  }
  .section-card {
    border-radius: 16px;
  }
  .section-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }
  .card-body {
    padding: 20px 20px 16px;
  }
  .language-trigger .flag-icon {
    font-size: 26px;
  }
  .language-trigger .lang-code {
    font-size: 15px;
  }
  .settings-item {
    padding: 12px 0;
  }
  .settings-item .item-icon {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }
  .settings-item .item-label {
    font-size: 15px;
  }
  .doc-view {
    padding: 28px 20px 40px;
  }
  .doc-content {
    padding: 24px;
    font-size: 15px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .settings-scroll,
  .doc-view,
  .section-card {
    animation: none !important;
    transition: none !important;
  }
  .settings-scroll:hover,
  .doc-view:hover,
  .section-card:hover {
    transform: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/personal-page/personal-settings/personal-settings.page.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,gCAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,8BAAA;AACF;;AAGE;EACE,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,kBAAA;EACA,cAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,mCAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;AAKI;EACE,8BAAA;AAHN;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,qCAAA;EACA,qDAAA;EACA,eAAA;AALF;AAOE;EACE,2BAAA;EACA,0CAAA;AALJ;AAQE;EACE,wBAAA;AANJ;AASE;EACE,mCAAA;EACA,sBAAA;AAPJ;AAUE;EACE,sBAAA;AARJ;;AAYA;EACE,cAAA;EACA,UAAA;EACA,kCAAA;EACA,0BAAA;AATF;AAWE;EACE,4CAAA;AATJ;;AAaA;EACE,OAAA;EACA,YAAA;EACA,uBAAA;AAVF;;AAaA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAVF;AAYE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,yCAAA;AAVJ;AAaE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;EACA,yBAAA;AAXJ;AAcE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,yBAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;AAbF;AAeE;EACE,aAAA;AAbJ;AAgBE;EACE,aAAA;AAdJ;AAiBE;EACE,yCAAA;AAfJ;AAkBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;AAlBJ;;AAuBE;EACE,uCAAA;EACA,UAAA;AApBJ;AAuBE;EACE,uCAAA;EACA,gBAAA;AArBJ;;AAyBA;EACE,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAtBF;;AAyBA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAtBF;AAwBE;EACE,eAAA;EACA,sBAAA;AAtBJ;AAyBE;EACE,gBAAA;AAvBJ;AAyBI;EACE,gBAAA;AAvBN;AA2BE;EACE,2BAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AA1BJ;AA6BE;EACE,8BAAA;EACA,gBAAA;EACA,gBAAA;AA3BJ;AA8BE;EAAK,eAAA;EAAiB,gBAAA;AA1BxB;AA2BE;EAAK,eAAA;EAAiB,gBAAA;AAvBxB;AAwBE;EAAK,eAAA;EAAiB,eAAA;AApBxB;;AAuBA;EACE;IACE,UAAA;IACA,2BAAA;EApBF;EAsBA;IACE,UAAA;IACA,wBAAA;EApBF;AACF;AAuBA;EAEI;IACE,kBAAA;EAtBJ;EA0BA;IACE,uBAAA;IACA,SAAA;EAxBF;EA2BA;IACE,mBAAA;EAzBF;EA2BE;IACE,2BAAA;IACA,0CAAA;EAzBJ;EA6BA;IACE,uBAAA;EA3BF;EA+BE;IACE,eAAA;EA7BJ;EAgCE;IACE,eAAA;EA9BJ;EAkCA;IACE,eAAA;EAhCF;EAkCE;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAhCJ;EAmCE;IACE,eAAA;EAjCJ;EAqCA;IACE,uBAAA;EAnCF;EAsCA;IACE,aAAA;IACA,eAAA;EApCF;AACF;AAuCA;EACE;;;IAGE,0BAAA;IACA,2BAAA;EArCF;EAuCE;;;IACE,0BAAA;EAnCJ;AACF","sourcesContent":[":host {\n  --settings-primary: #201157;\n  --settings-primary-text: #ffffff;\n  --settings-primary-dark: #201157;\n  --settings-accent: #EB266A;\n  --settings-heading: #201157;\n  --settings-body: #555555;\n  --settings-card-bg: #f5f5fa;\n  --settings-bg: #f6f3ff;\n  --settings-link: #201157;\n  --settings-btn-text: #ffffff;\n  --settings-ring-color: #201157;\n}\n\n.settings-header {\n  ion-toolbar {\n    --border-width: 0 !important;\n    --background: var(--settings-primary);\n    --color: var(--settings-primary-text);\n    --min-height: 52px;\n    padding: 0 4px;\n\n    &.settings-toolbar {\n      border-bottom: none;\n    }\n  }\n}\n\n.settings-title {\n  font-size: 17px;\n  font-weight: 600;\n  letter-spacing: -0.2px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  padding: 0 48px;\n  pointer-events: none;\n}\n\n.header-icon {\n  width: 20px;\n  height: 20px;\n  color: var(--settings-primary-text);\n}\n\n.settings-content {\n  --background: var(--settings-bg);\n\n  ::ng-deep {\n    .inner-scroll {\n      background: var(--settings-bg);\n    }\n  }\n}\n\n.settings-scroll {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 16px 32px;\n  max-width: 480px;\n  margin: 0 auto;\n  animation: fadeInUp 0.35s ease both;\n}\n\n.section-card {\n  display: flex;\n  background: #ffffff;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n\n  & + & {\n    animation: fadeInUp 0.35s ease both;\n    animation-delay: 0.08s;\n  }\n\n  & + & + & {\n    animation-delay: 0.16s;\n  }\n}\n\n.card-accent {\n  flex-shrink: 0;\n  width: 3px;\n  background: var(--settings-accent);\n  border-radius: 0 2px 2px 0;\n\n  &--danger {\n    background: var(--ion-color-danger, #f04141);\n  }\n}\n\n.card-body {\n  flex: 1;\n  min-width: 0;\n  padding: 16px 16px 12px;\n}\n\n.section-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--settings-body);\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  opacity: 0.6;\n}\n\n.language-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0 4px;\n\n  .flag-icon {\n    font-size: 22px;\n    line-height: 1;\n    margin: 0;\n    border-radius: 3px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n  }\n\n  .lang-code {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--settings-heading);\n    letter-spacing: 0.3px;\n    text-transform: uppercase;\n  }\n\n  .chevron-icon {\n    margin-left: auto;\n    width: 14px;\n    height: 14px;\n    color: var(--settings-body);\n    opacity: 0.35;\n    transform: rotate(180deg);\n  }\n}\n\n.settings-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 0.75;\n  }\n\n  &:active {\n    opacity: 0.55;\n  }\n\n  + .settings-item {\n    border-top: 1px solid rgba(0, 0, 0, 0.05);\n  }\n\n  .item-icon {\n    flex-shrink: 0;\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n    color: var(--settings-link);\n    opacity: 0.7;\n  }\n\n  .item-label {\n    flex: 1;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--settings-heading);\n    line-height: 1.3;\n  }\n\n  .chevron-icon {\n    width: 14px;\n    height: 14px;\n    color: var(--settings-body);\n    opacity: 0.25;\n    transform: rotate(180deg);\n    flex-shrink: 0;\n  }\n}\n\n.card-danger {\n  .item-icon--danger {\n    color: var(--ion-color-danger, #f04141);\n    opacity: 1;\n  }\n\n  .item-label--danger {\n    color: var(--ion-color-danger, #f04141);\n    font-weight: 500;\n  }\n}\n\n.doc-view {\n  padding: 20px 16px 32px;\n  max-width: 480px;\n  margin: 0 auto;\n  animation: fadeInUp 0.3s ease both;\n}\n\n.doc-content {\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 20px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  font-size: 14px;\n  line-height: 1.65;\n  color: var(--settings-body);\n\n  * {\n    max-width: 100%;\n    word-break: break-word;\n  }\n\n  p {\n    margin: 0 0 12px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  a {\n    color: var(--settings-link);\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 8px;\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    color: var(--settings-heading);\n    font-weight: 600;\n    line-height: 1.3;\n  }\n\n  h1 { font-size: 20px; margin: 0 0 12px; }\n  h2 { font-size: 18px; margin: 0 0 10px; }\n  h3 { font-size: 16px; margin: 0 0 8px; }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .settings-header {\n    ion-toolbar {\n      --min-height: 56px;\n    }\n  }\n\n  .settings-scroll {\n    padding: 28px 20px 40px;\n    gap: 18px;\n  }\n\n  .section-card {\n    border-radius: 16px;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n    }\n  }\n\n  .card-body {\n    padding: 20px 20px 16px;\n  }\n\n  .language-trigger {\n    .flag-icon {\n      font-size: 26px;\n    }\n\n    .lang-code {\n      font-size: 15px;\n    }\n  }\n\n  .settings-item {\n    padding: 12px 0;\n\n    .item-icon {\n      width: 20px;\n      height: 20px;\n      font-size: 20px;\n    }\n\n    .item-label {\n      font-size: 15px;\n    }\n  }\n\n  .doc-view {\n    padding: 28px 20px 40px;\n  }\n\n  .doc-content {\n    padding: 24px;\n    font-size: 15px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .settings-scroll,\n  .doc-view,\n  .section-card {\n    animation: none !important;\n    transition: none !important;\n\n    &:hover {\n      transform: none !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
